import { useTranslation } from 'react-i18next';

import * as graphql from '@treams/treams-network';

/** The selectable review scores, in display order, with their translated titles. */
export default function useScoreOptions() {
	const { t } = useTranslation();

	return [
		{
			title: t('talentReviews.v2.motivations.score.excellent'),
			value: graphql.TalentReviewPlacementScore.Excellent,
		},
		{
			title: t('talentReviews.v2.motivations.score.good'),
			value: graphql.TalentReviewPlacementScore.Good,
		},
		{
			title: t('talentReviews.v2.motivations.score.roomForImprovement'),
			value: graphql.TalentReviewPlacementScore.RoomForImprovement,
		},
		{
			title: t('talentReviews.v2.motivations.score.insufficient'),
			value: graphql.TalentReviewPlacementScore.Insufficient,
		},
		{
			title: t('talentReviews.v2.motivations.score.cannotBeReviewed'),
			value: graphql.TalentReviewPlacementScore.CannotBeReviewed,
		},
	];
}
